import React, { FC } from 'react';

const OWTabTitleWithSubTitle: FC<any> = ({ title, subTitle }): React.ReactElement => {
	return (
		<div className="my-4 flex flex-row items-baseline gap-2">
			<h6>{title}</h6>
			<div className="h5regular text-black/45">{subTitle}</div>
		</div>
	);
};

export default OWTabTitleWithSubTitle;
